var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_gg", style: { width: _vm.width } }, [
    _c("div", { staticClass: "_ggfr" }, [
      _c("div", { staticClass: "_ggcl" }, [
        _c(
          "svg",
          {
            staticClass: "_ggso",
            style: _vm.transform,
            attrs: { viewBox: "0 0 64 64" }
          },
          [
            _c("clipPath", { attrs: { id: "_ggcp" + _vm._uid } }, [
              _c("path", {
                attrs: {
                  d:
                    "M32 0A32 32 0 1 0 32 64A32 32 0 1 0 32 0zM32 " +
                    _vm.thickness +
                    "A" +
                    (32 - _vm.thickness) +
                    " " +
                    (32 - _vm.thickness) +
                    " 0 1 1 32 " +
                    (64 - _vm.thickness) +
                    "A" +
                    (32 - _vm.thickness) +
                    " " +
                    (32 - _vm.thickness) +
                    " 0 1 1 32 " +
                    _vm.thickness +
                    "z"
                }
              })
            ]),
            _c(
              "radialGradient",
              { attrs: { id: "_ggrg" } },
              [
                _c("stop", { attrs: { offset: "75%", "stop-opacity": "0" } }),
                _c("stop", {
                  attrs: { offset: "100%", "stop-opacity": "0.05" }
                })
              ],
              1
            ),
            _c("g", { attrs: { "clip-path": "url(#_ggcp" + _vm._uid + ")" } }, [
              _c("rect", {
                staticClass: "_ggbg",
                attrs: { x: "0", y: "0", width: "64", height: "64" }
              }),
              _vm.solid
                ? _c("rect", {
                    staticClass: "_ggro",
                    attrs: { x: "0", y: "32", width: "64", height: "32" }
                  })
                : _vm._e(),
              _c("ellipse", {
                attrs: {
                  cx: "32",
                  cy: "32",
                  rx: "33",
                  ry: "32",
                  fill: "url(#_ggrg)"
                }
              })
            ])
          ],
          1
        )
      ]),
      _vm.needle
        ? _c(
            "svg",
            {
              staticClass: "_ggnd",
              style: _vm.transform,
              attrs: { viewBox: "0 0 64 8" }
            },
            [
              _c("path", { attrs: { d: "M63.75 7.995L0 4 63.75.005z" } }),
              _c("circle", { attrs: { cx: "64", cy: "4", r: "4" } })
            ]
          )
        : _vm._e(),
      _vm.tick
        ? _c(
            "svg",
            {
              staticClass: "_ggtk",
              style: {
                opacity: _vm.tickOpacity,
                strokeWidth: _vm.tickThickness
              },
              attrs: { viewBox: "0 0 64 32" }
            },
            [
              _vm._l(_vm.tick, function(t) {
                return _c("path", {
                  attrs: { d: _vm._d(t), "vector-effect": "non-scaling-stroke" }
                })
              }),
              _vm._l(_vm.tick, function(t) {
                return _c(
                  "text",
                  {
                    attrs: {
                      x: "32",
                      y: 6 + _vm.thickness,
                      transform:
                        "rotate(" +
                        ((t - _vm.min) / (_vm.max - _vm.min) - 0.5) * 180 +
                        " 32 32)",
                      "vector-effect": "non-scaling-stroke"
                    }
                  },
                  [_vm._v(_vm._s(t))]
                )
              })
            ],
            2
          )
        : _vm._e()
    ]),
    _vm.$slots.default || _vm.$scopedSlots.default
      ? _c(
          "div",
          { staticClass: "_ggca" },
          [_vm._t("default", null, { value: _vm.value })],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }